<template>
  <div class="flex flex-wrap items-center gap-3">
    <SharedPrice
      v-if="unitPrice"
      :discounted="listPrice"
      :value="unitPrice"
      class="text-left text-base font-medium"
    />
    <SharedPrice
      v-if="listPrice"
      :value="listPrice"
      class="text-sm font-normal leading-snug text-medium-grey line-through"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps(["listPrice", "unitPrice"]);
</script>
